import { Lock } from '@/components/Lock';
import { TPage } from '@/types';
import { Typography } from '@data-products-and-ai/react-components';

import garage from '@/assets/places/garage.jpg';

const Sign = ({ team, target }: TPage) => {
  return (
    <Lock
      hasLogo={false}
      target={target}
      combination="270"
      text={
        <Typography>
          <div style={{ marginBottom: 20 }}>
            <img src={garage} alt="" style={{ width: 300, height: 'auto' }} />
          </div>
          Cats possess remarkable memory abilities but we believe you won{`'`}t
          remember what the number replaced by the question mark is.
          <br /> But cats always find a way...
        </Typography>
      }
    />

    /*   <Lock
      target={target}
      lockType="image"
      combination="3,0,2,1,4,5,7,6,9,8"
      text={
        <Typography tag="h1">
          Great job so fAr but aRe you All aGain prEpared? Go aROUND the message
          and Find aLl yOu need tO be in the Right path!
        </Typography>
      }
    /> */
  );
};

export default Sign;
